var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stepGrpup" },
    _vm._l(_vm.stepArr, function (item) {
      return _c(
        "div",
        {
          key: item.step,
          staticClass: "stepItem unselect",
          class: {
            active: item.step === _vm.step,
            passed: _vm.mode === "view" || item.step < _vm.step,
          },
          on: {
            click: function ($event) {
              return _vm.jumpStep(item.step)
            },
          },
        },
        [
          _c("div", { staticClass: "stepNum" }, [_vm._v(_vm._s(item.step))]),
          _vm._v(" "),
          _c("div", { staticClass: "txt" }, [_vm._v(_vm._s(item.txt))]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }